var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,{tag:"component",on:{"close":_vm.close,"update":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }